import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bcea7b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Not supported by your Browser/Device", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enable them", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_split_pane = _resolveComponent("ion-split-pane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_split_pane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "menu-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_list_header, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Menu")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_note, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Please select the timer you need.")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPages, (p, i) => {
                        return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                          "auto-hide": false,
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              onClick: ($event: any) => (_ctx.selectedIndex = i),
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: "none",
                              detail: false,
                              class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === i }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  ios: p.iosIcon,
                                  md: p.mdIcon
                                }, null, 8, ["ios", "md"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "class"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Settings")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" You are on: " + _toDisplayString(_ctx.platforms()) + " ", 1),
                          _hoisted_1,
                          _createTextVNode(" Permission: " + _toDisplayString(_ctx.notificationPermission), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_list, { id: "settings-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.notifyMe())),
                        disabled: _ctx.notificationPermission === 'denied'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            ios: _ctx.settingsOutline,
                            md: _ctx.settingsSharp
                          }, null, 8, ["ios", "md"]),
                          (_ctx.notificationPermission === 'granted')
                            ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Test notifications")
                                ]),
                                _: 1
                              }))
                            : (_ctx.notificationPermission === 'nosupport')
                              ? (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("No notifications"),
                                    _hoisted_2
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.notificationPermission !== 'denied')
                                ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Enable notifications")
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.notificationPermission === 'denied')
                                  ? (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Notifications are blocked"),
                                        _hoisted_3
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.platforms().includes('hybrid'))
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleStatusBar()))
                          }, {
                            default: _withCtx(() => [
                              (_ctx.statusBarVisible)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    slot: "start",
                                    ios: _ctx.expandOutline,
                                    md: _ctx.expandSharp
                                  }, null, 8, ["ios", "md"]))
                                : (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 1,
                                    slot: "start",
                                    ios: _ctx.contractOutline,
                                    md: _ctx.contractSharp
                                  }, null, 8, ["ios", "md"])),
                              (_ctx.statusBarVisible)
                                ? (_openBlock(), _createBlock(_component_ion_label, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Fullscreen")
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_ion_label, { key: 3 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Exit Fullscreen")
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.testSound()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            ios: _ctx.volumeHighOutline,
                            md: _ctx.volumeHighSharp
                          }, null, 8, ["ios", "md"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Test sound")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.awakeSupported())
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 1,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAwake()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "start",
                                ios: _ctx.bedOutline,
                                md: _ctx.bedSharp
                              }, null, 8, ["ios", "md"]),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Stay awake")
                                ]),
                                _: 1
                              }),
                              (_ctx.stayAwake)
                                ? (_openBlock(), _createBlock(_component_ion_icon, {
                                    key: 0,
                                    slof: "end",
                                    ios: _ctx.checkmarkOutline,
                                    md: _ctx.checkmarkSharp
                                  }, null, 8, ["ios", "md"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}